import { useSelector } from 'react-redux';
import { selectFeatureFlags } from 'core/userContext';
import { MI } from 'modules/movableInk';
import { MOVABLE_INK_ADDON_HANDLE } from '../constants';

export const useMovableInkAddOn = () => {
  const { [MI]: isMovableInkEnabled = false } = useSelector(selectFeatureFlags);

  return {
    id: MOVABLE_INK_ADDON_HANDLE,
    enabled: isMovableInkEnabled,
  };
};
